import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { withFocusToggleClassName } from "../../../../util/withFocusClassName";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { TextAreaV2 } from "../../../textareaV2";
export const ComboboxTextArea = withFocusToggleClassName(styled(TextAreaV2)`
    display: block;
    width: 100%;
    border: none;
    color: ${color("color--text--neutral--strong")};

    // Override some UA styles.
    font-family: inherit;
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return menuTheme.fontSize(themeMode);
}};

    &:focus-within::before {
        border: none;
        box-shadow: none;
    }
`);
//# sourceMappingURL=ComboBoxTextArea.js.map